<template>
  <div style="min-height: 750px;" v-if="d_usrShpBundWdm && !d_frontendLoading">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['add_dataset_list'][StoreLang] }}
        <i class="fa fa-info-circle"
           style="color:#2492FF;margin-left:5px;"
           @click="$help('dataset_cancel_information', StoreLang)">
        </i>
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
        <template v-if="d_bundleListLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <b-row style="margin-bottom: 10px;">
            <b-col sm="12" lg="6"> </b-col>
            <b-col sm="12" lg="6" style="text-align: right;">
              <b-button size="sm" v-if="d_shopList.length > 0" @click="f_newBundle()" variant="primary">
                {{ StoreLangTranslation.data['new_dataset'][StoreLang] }}
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" lg="12">
              <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
            </b-col>
          </b-row>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="2">
              <strong> {{ d_usrShpBundWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
            </b-col>
            <b-col sm="12" lg="9">
              <strong> {{ d_usrShpBundWdm['0']['parameters']['1']['name']['translation'][StoreLang] }} </strong>
            </b-col>
            <b-col sm="12" lg="1"> </b-col>
          </b-row>
          <b-row v-for="(wdmr_item, wdmr_item_ind) in d_usrCreatedBundleList" v-if="f_searchUserShopBundle(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'">
            <b-col sm="12" lg="2">
              
              <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                <!-- <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span> -->
                <span :style="wdmr_item.data['0']['0']['val']['value'] === '1' ? 'color: green;' : 'color: red;'">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
              </template>
            
            </b-col>
            <b-col sm="12" lg="9">
              
              <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['lang'] && wdmr_item.data['0']['1']['lang'][StoreLang]">
                <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['lang'][StoreLang] }}</span>
              </template>
              <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['val']">
                <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['val'] }}</span>
              </template>
            
            </b-col>
            <b-col sm="12" lg="1">
              <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                <template slot="button-content">
                  {{ StoreLangTranslation.data['action'][StoreLang] }}
                </template>
                <b-dropdown-item @click="f_showBundle(wdmr_item.client_id, wdmr_item.parent_c.id)"><i class="fa fa-eye"></i> {{ StoreLangTranslation.data['show'][StoreLang] }} </b-dropdown-item>
                <b-dropdown-item v-if="wdmr_item['data']['0']['0'] && wdmr_item['data']['0']['0']['val']['value'] && wdmr_item['data']['0']['0']['val']['value'] !== '1'" @click="f_editBundle(wdmr_item.client_id, wdmr_item.parent_c.id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['edit'][StoreLang] }} </b-dropdown-item>

                <b-dropdown-item v-if="wdmr_item['data']['0']['0'] && wdmr_item['data']['0']['0']['val']['value'] && wdmr_item['data']['0']['0']['val']['value'] === '1'" @click="f_copyShortLink(wdmr_item.id)">
                  <i class="fa fa-share-alt mr-2"></i>
                  {{ StoreLangTranslation.data['create_short_link'][StoreLang] }}
                </b-dropdown-item>
                <b-dropdown-item @click="f_copyDataAvailabilityStatement(wdmr_item.id, 'en')"><i class="fa fa-clone"></i> {{ StoreLangTranslation.data['copy_data_availability_statement_en'][StoreLang] }} </b-dropdown-item>
                <b-dropdown-item @click="f_copyDataAvailabilityStatement(wdmr_item.id, 'tr')"><i class="fa fa-clone"></i> {{ StoreLangTranslation.data['copy_data_availability_statement_tr'][StoreLang] }} </b-dropdown-item>
                <b-dropdown-item @click="f_goToProject(wdmr_item.client_id)"><i class="fa fa-bar-chart"></i> {{ StoreLangTranslation.data['go_to_project'][StoreLang] }} </b-dropdown-item>
                <!-- <b-dropdown-item v-if="wdmr_item['data']['0']['0'] && wdmr_item['data']['0']['0']['val']['value'] && wdmr_item['data']['0']['0']['val']['value'] == '1'" @click="f_showCancel(wdmr_item.client_id, wdmr_item.parent_c.id)"><i class="fa fa-trash"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }} </b-dropdown-item> -->
                <!-- <b-dropdown-item v-if="wdmr_item['data']['0']['0'] && wdmr_item['data']['0']['0']['val']['value'] && wdmr_item['data']['0']['0']['val']['value'] == '1'" @click="$help('dataset_cancel_information', StoreLang)"><i class="fa fa-trash"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }} </b-dropdown-item> -->
              </b-dropdown>
            </b-col>
            <b-col cols="12" v-if="d_OrderList[wdmr_item['client_id']] && d_OrderList[wdmr_item['client_id']].user_list.length > 0">
            <!-- <b-col cols="12" v-if="d_OrderList['wisdom_0d4206b1-fabe-4078-96e4-4f8b575c1aa9'] && d_OrderList['wisdom_0d4206b1-fabe-4078-96e4-4f8b575c1aa9'].user_list.length > 0"> -->
              <b-row>
                <b-col sm="12" lg="2"></b-col>
                <b-col sm="12" lg="10">
                  <strong>{{ StoreLangTranslation.data['dataset_requesters'][StoreLang] }}</strong>
                  <b-row v-for="user_item in d_OrderList[wdmr_item['client_id']].user_list"><b-col sm="12" lg="12"> {{ user_item.user }} </b-col></b-row>
                  <!-- <b-row v-for="user_item in d_OrderList['wisdom_0d4206b1-fabe-4078-96e4-4f8b575c1aa9'].user_list"><b-col sm="12" lg="12"> {{ user_item.user }} </b-col></b-row> -->
                  <!-- <span v-for="user_item in d_OrderList['wisdom_0d4206b1-fabe-4078-96e4-4f8b575c1aa9'].user_list"> {{ user_item.user }}, </span> -->
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>


    <b-modal v-if="d_showBundleModal" id="d_showBundleModal" v-model="d_showBundleModal" scrollable hide-footer :title="StoreLangTranslation.data['show'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template v-if="d_modalLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template v-else>
        <template v-if="d_datasetViewLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <w-table2 style="transition: 2s; transform: none;" v-if="d_datasetWTable" :key="'dataset_view'" :p_tableDetails="d_datasetWTable"></w-table2>
        </template>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.bundle_name }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_productData.wanalyzer_project_id[StoreLang] }}
          </b-col>
        </b-row>
        <div v-if="d_bundleData.which_one_best_describes_your_reason_for_sharing_dataset">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['51']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_bundleData.dataset_usage_type }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['51'].options[d_bundleData.which_one_best_describes_your_reason_for_sharing_dataset].translation[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <!-- {{ d_bundleData.about_dataset }} -->
            <div v-html="d_bundleData.about_dataset"></div>
          </b-col>
        </b-row>
        <div v-if="d_bundleData.demo_dataset">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_bundleData.demo_dataset }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['35'].options[d_bundleData.demo_dataset].translation[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <div v-if="d_bundleData.dataset_usage_type">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_bundleData.dataset_usage_type }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['40'].options[d_bundleData.dataset_usage_type].translation[StoreLang] }}
            </b-col>
          </b-row>
        </div>
        <div v-if="d_bundleData.dataset_usage_type == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['52']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.visiting_research_institution_request_text }}
            </b-col>
          </b-row>
        </div>
        <hr>
        <div v-if="d_bundleData.licence_type">
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['46']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <!-- {{ d_bundleData.licence_type }} -->
              <!-- {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }} -->
              {{ d_usrShpBundWdm['0']['parameters']['46'].options[d_bundleData.licence_type].translation[StoreLang] }}
            </b-col>
          </b-row>
          <hr>
        </div>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.row_count }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.column_count }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <!-- {{ d_bundleData.various_variables }} -->
            <div v-html="d_bundleData.various_variables"></div>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['43']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.methodologies_and_analyses_to_be_excluded }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['44']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.data_collection_center_count }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['45']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.data_collection_centers }}
          </b-col>
        </b-row>
        <div v-if="d_bundleData.special_acknowledgement_request_status == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['42']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.special_acknowledgement_text }}
            </b-col>
          </b-row>
        </div>
        <!-- <div v-if="d_bundleData.dataset_publication_status_in_an_article == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['48']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.journal_name }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['49']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.article_title }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['50']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.link }}
            </b-col>
          </b-row>
        </div> -->
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['28']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.dataset_creator_note }}
          </b-col>
        </b-row>
        <div v-if="d_bundleData.communication_with_the_user_requesting_the_dataset == '1'">
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['30']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.dataset_creator_phone }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['31']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.dataset_creator_mail }}
            </b-col>
          </b-row>
          <hr>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ d_usrShpBundWdm['0']['parameters']['32']['name']['translation'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              {{ d_bundleData.dataset_creator_note_to_requester }}
            </b-col>
          </b-row>
        </div>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['53']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.ethics_committee_approval_institution }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['54']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.ethics_committee_date }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['55']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_bundleData.ethics_committee_protocol_number }}
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px; padding-top: 10px;">
          <b-col sm="12" lg="12">
            <b-button v-if="d_bundleData['status'] !== '1'" @click="f_changeToModal('edit')" variant="warning">{{ StoreLangTranslation.data['edit'][StoreLang] }}</b-button>
            <b-button @click="d_showBundleModal = false" variant="danger" style="float: right;">{{ StoreLangTranslation.data['cancel'][StoreLang] }}</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <b-modal
      v-if="d_editBundleModal"
      id="d_editBundleModal"
      v-model="d_editBundleModal"
      scrollable
      hide-footer
      :title="StoreLangTranslation.data['edit'][StoreLang]"
      centered
      header-bg-variant="info"
      header-text-variant="dark"
      size="xl"
      :no-close-on-backdrop="d_saveLoading"
      :no-close-on-esc="d_saveLoading"
      :hide-header-close="d_saveLoading"
    >

      <template v-if="d_modalLoading || d_saveLoading">
        <b-spinner variant="primary"></b-spinner>
      </template>

      <template v-else>

        <!-- ================= DATASET GENERAL INFORMATION ================= -->

        <b-card-header header-bg-variant="white">
          <h6>
            <i class="fa fa-calculator"></i>
            {{ StoreLangTranslation.data['dataset_general_information'][StoreLang] }}
            <i class="fa fa-info-circle"
               style="color:#2492FF;margin-left:5px;"
               @click="$help('dataset_general_information', StoreLang)">
            </i>
          </h6>
        </b-card-header>

        <b-card-body>

          <!-- Dataset Name -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('add_dataset_name', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <b-form-textarea rows="1" v-model="d_bundleData.bundle_name"></b-form-textarea>
            </b-col>
          </b-row>
          <hr>

          <!-- Dataset License -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['46']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('add_dataset_license_type', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <select class="form-control" v-model="d_bundleData.licence_type">
                <option value="">-</option>
                <option v-for="op in d_usrShpBundWdm['0']['parameters']['46'].options" :value="op.value">
                  {{ op.translation[StoreLang] }}
                </option>
              </select>
            </b-col>
          </b-row>
          <hr>

          <!-- Reason for Sharing -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['51']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('which_best_describes_reason_for_sharing_dataset', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <select class="form-control" v-model="d_bundleData.which_one_best_describes_your_reason_for_sharing_dataset">
                <option value="">-</option>
                <option v-for="op in d_usrShpBundWdm['0']['parameters']['51'].options" :value="op.value">
                  {{ op.translation[StoreLang] }}
                </option>
              </select>
            </b-col>
          </b-row>
          <hr>

          <!-- Creator Note -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['28']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('dataset_creator_note', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <b-form-textarea rows="3" v-model="d_bundleData.dataset_creator_note"></b-form-textarea>
            </b-col>
          </b-row>

        </b-card-body>


      <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
        <b-row>
          <b-col sm="12" lg="8">
            <h6>
              <i class="fa fa-calculator"></i>
              {{ StoreLangTranslation.data['dataset_contact_information'][StoreLang] }}
            </h6>
          </b-col>
          <b-col sm="12" lg="4" style="text-align: right;"></b-col>
        </b-row>
      </b-card-header>

      <b-card-body>
        <!-- Communication preference -->
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>
              {{ d_usrShpBundWdm['0']['parameters']['29']['name']['translation'][StoreLang] }}
            </strong>
            <i
              class="fa fa-info-circle"
              style="color:#2492FF; margin-left:5px; cursor:pointer;"
              @click="$help('communication_with_user_requesting_dataset', StoreLang)">
            </i>
          </b-col>
          <b-col sm="12" lg="8">
            <select
              class="form-control"
              v-model="d_bundleData.communication_with_the_user_requesting_the_dataset">
              <option value="" selected>-</option>
              <option
                v-for="(op, op_index) in d_usrShpBundWdm['0']['parameters']['29'].options"
                :key="op_index"
                :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>

        <!-- Contact details -->
        <div v-if="d_bundleData.communication_with_the_user_requesting_the_dataset == '1'">
          <hr>

          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['30']['name']['translation'][StoreLang] }}
              </strong>

            </b-col>
            <b-col sm="12" lg="8">
              <b-form-textarea
                rows="1"
                class="form-control"
                v-model="d_bundleData.dataset_creator_phone">
              </b-form-textarea>
            </b-col>
          </b-row>

          <hr>

          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['31']['name']['translation'][StoreLang] }}
              </strong>

            </b-col>
            <b-col sm="12" lg="8">
              <b-form-textarea
                rows="1"
                class="form-control"
                v-model="d_bundleData.dataset_creator_mail">
              </b-form-textarea>
            </b-col>
          </b-row>

          <hr>

          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['32']['name']['translation'][StoreLang] }}
              </strong>

            </b-col>
            <b-col sm="12" lg="8">
              <b-form-textarea
                rows="3"
                class="form-control"
                v-model="d_bundleData.dataset_creator_note_to_requester">
              </b-form-textarea>
            </b-col>
          </b-row>
        </div>

        <hr>
      </b-card-body>



        <!-- ================= DATASET FEATURES ================= -->

        <b-card-header header-bg-variant="white">
          <h6>
            <i class="fa fa-calculator"></i>
            {{ StoreLangTranslation.data['dataset_features'][StoreLang] }}
          </h6>
        </b-card-header>

        <b-card-body>

          <!-- About Dataset -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('about_dataset', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <b-row>
                <b-col cols="12">
                  <b-button :class="{ active: d_inputEditorMode === 'html' }"  variant="outline-secondary" @click="f_changeInputEditorMode('html')" style="font-size: 14px; margin-right: 2px;">{{ StoreLangTranslation.data['html_editor'][StoreLang] }}</b-button>
                  <b-button :class="{ active: d_inputEditorMode === 'text' }"  variant="outline-secondary" @click="f_changeInputEditorMode('text', d_bundleData)" style="font-size: 14px;">{{ StoreLangTranslation.data['text_editor'][StoreLang] }}</b-button>
                </b-col>
              </b-row>
              <template v-if="d_inputEditorMode == 'text'">
                <b-form-textarea rows="3" class="form-control" v-model="d_bundleData.about_dataset"></b-form-textarea>
              </template>
              <template v-else-if="d_inputEditorMode == 'html'">
                <html-editor :p_html_text="d_bundleData.about_dataset" :p_htmlElementId="'website_html_edit_about_dataset'"></html-editor>
              </template>
            </b-col>
          </b-row>
          <hr>

          <!-- Various Variables -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('various_variables', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <b-row>
                <b-col cols="12">
                  <b-button :class="{ active: d_inputEditorMode === 'html' }"  variant="outline-secondary" @click="f_changeInputEditorMode('html')" style="font-size: 14px; margin-right: 2px;">{{ StoreLangTranslation.data['html_editor'][StoreLang] }}</b-button>
                  <b-button :class="{ active: d_inputEditorMode === 'text' }"  variant="outline-secondary" @click="f_changeInputEditorMode('text', d_bundleData)" style="font-size: 14px;">{{ StoreLangTranslation.data['text_editor'][StoreLang] }}</b-button>
                </b-col>
              </b-row>
              <template v-if="d_inputEditorMode == 'text'">
                <b-form-textarea rows="3" class="form-control" v-model="d_bundleData.various_variables"></b-form-textarea>
              </template>
              <template v-else-if="d_inputEditorMode == 'html'">
                <html-editor :p_html_text="d_bundleData.various_variables" :p_htmlElementId="'website_html_edit_various_variables'"></html-editor>
              </template>
            </b-col>


          </b-row>
          <hr>

          <!-- Demo Dataset -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['35']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('demo_dataset', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <select class="form-control" v-model="d_bundleData.demo_dataset">
                <option value="">-</option>
                <option v-for="op in d_usrShpBundWdm['0']['parameters']['35'].options" :value="op.value">
                  {{ op.translation[StoreLang] }}
                </option>
              </select>
            </b-col>
          </b-row>
          <hr>

          <!-- Row Count -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('row_count', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <b-form-input type="number" v-model="d_bundleData.row_count"></b-form-input>
            </b-col>
          </b-row>
          <hr>

          <!-- Column Count -->
          <b-row>
            <b-col lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;"
                   @click="$help('column_count', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col lg="8">
              <b-form-input type="number" v-model="d_bundleData.column_count"></b-form-input>
            </b-col>
          </b-row>

        </b-card-body>


        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row>
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-calculator"></i>
                {{ StoreLangTranslation.data['dataset_subscriber_features'][StoreLang] }}
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <!-- Dataset Usage Type -->
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;display:inline-block;"
                   @click="$help('dataset_usage_type', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col sm="12" lg="8">
              <select class="form-control" v-model="d_bundleData.dataset_usage_type">
                <option value="" selected>-</option>
                <option
                  v-for="(op, op_index) in d_usrShpBundWdm['0']['parameters']['40'].options"
                  :value="op.value">
                  {{ op.translation[StoreLang] }}
                </option>
              </select>
            </b-col>
          </b-row>

          <hr>

          <!-- Visiting Researcher Institution Requirement -->
          <div v-if="d_bundleData.dataset_usage_type == '1'">
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['52']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;display:inline-block;"
                     @click="$help('visiting_researcher_institution_request_text', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-textarea
                  rows="3"
                  class="form-control"
                  :placeholder="StoreLangTranslation.data['placeholder_visiting_research_institution_request_text'][StoreLang]"
                  v-model="d_bundleData.visiting_research_institution_request_text">
                </b-form-textarea>
              </b-col>
            </b-row>
            <hr>
          </div>

          <!-- Special Acknowledgement Request Status -->
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>
                {{ d_usrShpBundWdm['0']['parameters']['41']['name']['translation'][StoreLang] }}
                <i class="fa fa-info-circle"
                   style="color:#2492FF;margin-left:5px;display:inline-block;"
                   @click="$help('special_acknowledgement_request_status', StoreLang)">
                </i>
              </strong>
            </b-col>
            <b-col sm="12" lg="8">
              <select
                class="form-control"
                v-model="d_bundleData.special_acknowledgement_request_status">
                <option value="" selected>-</option>
                <option
                  v-for="(op, op_index) in d_usrShpBundWdm['0']['parameters']['41'].options"
                  :value="op.value">
                  {{ op.translation[StoreLang] }}
                </option>
              </select>
            </b-col>
          </b-row>

          <!-- Special Acknowledgement Text -->
          <div v-if="d_bundleData.special_acknowledgement_request_status == '1'">
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['42']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;display:inline-block;"
                     @click="$help('special_acknowledgement_request_status', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-textarea
                  rows="1"
                  class="form-control"
                  v-model="d_bundleData.special_acknowledgement_text">
                </b-form-textarea>
              </b-col>
            </b-row>
          </div>

          <hr>
        </b-card-body>


            <!-- ================= DATASET AUTHORS and ARTICLE INFORMATION ================= -->
          <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
            <b-row>
              <b-col sm="12" lg="8">
                <h6>
                  <i class="fa fa-calculator"></i>
                  {{ StoreLangTranslation.data['dataset_author_and_article_information'][StoreLang] }}
                </h6>
              </b-col>
              <b-col sm="12" lg="4" style="text-align: right;"></b-col>
            </b-row>
          </b-card-header>


          <b-card-body>

            <!-- ================= DATASET AUTHORS ================= -->
            <b-row style="margin: 3px; margin-bottom: 10px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['57']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('dataset_authors', StoreLang)">
                  </i>
                </strong>
              </b-col>

              <b-col sm="12" lg="8">
                <button class="btn btn-success" @click="f_addAuthor()">+</button>
              </b-col>
            </b-row>

            <div v-for="(author_item, author_index) in d_bundleData.author_list"
                 :key="'author_' + author_index">

              <!-- Author Title -->
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="1">
                  <button class="btn btn-danger" @click="f_removeAuthor(author_index)">-</button>
                </b-col>
                <b-col sm="12" lg="3">
                  <strong>
                    {{ d_usrShpBundWdm['0']['parameters']['57']['parameters']['60']['name']['translation'][StoreLang] }}
                    <i class="fa fa-info-circle"
                       style="color:#2492FF;margin-left:5px;"
                       @click="$help('author_title', StoreLang)">
                    </i>
                  </strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input class="form-control" v-model="author_item.title"></b-form-input>
                </b-col>
              </b-row>

              <!-- Author Firstname -->
              <b-row style="margin: 3px;">
                <b-col lg="1"></b-col>
                <b-col lg="3">
                  <strong>
                    {{ d_usrShpBundWdm['0']['parameters']['57']['parameters']['58']['name']['translation'][StoreLang] }}
                    <i class="fa fa-info-circle"
                       style="color:#2492FF;margin-left:5px;"
                       @click="$help('author_firstname', StoreLang)">
                    </i>
                  </strong>
                </b-col>
                <b-col lg="8">
                  <b-form-input class="form-control" v-model="author_item.firstname"></b-form-input>
                </b-col>
              </b-row>

              <!-- Author Lastname -->
              <b-row style="margin: 3px;">
                <b-col lg="1"></b-col>
                <b-col lg="3">
                  <strong>
                    {{ d_usrShpBundWdm['0']['parameters']['57']['parameters']['59']['name']['translation'][StoreLang] }}
                    <i class="fa fa-info-circle"
                       style="color:#2492FF;margin-left:5px;"
                       @click="$help('author_lastname', StoreLang)">
                    </i>
                  </strong>
                </b-col>
                <b-col lg="8">
                  <b-form-input class="form-control" v-model="author_item.lastname"></b-form-input>
                </b-col>
              </b-row>

              <!-- Author Mail -->
              <b-row style="margin: 3px;">
                <b-col lg="1"></b-col>
                <b-col lg="3">
                  <strong>
                    {{ d_usrShpBundWdm['0']['parameters']['57']['parameters']['61']['name']['translation'][StoreLang] }}
                    <i class="fa fa-info-circle"
                       style="color:#2492FF;margin-left:5px;"
                       @click="$help('author_mail', StoreLang)">
                    </i>
                  </strong>
                </b-col>
                <b-col lg="8">
                  <b-form-input class="form-control" v-model="author_item.mail"></b-form-input>
                </b-col>
              </b-row>

              <!-- Author Institution -->
              <b-row style="margin: 3px;">
                <b-col lg="1"></b-col>
                <b-col lg="3">
                  <strong>
                    {{ d_usrShpBundWdm['0']['parameters']['57']['parameters']['62']['name']['translation'][StoreLang] }}
                    <i class="fa fa-info-circle"
                       style="color:#2492FF;margin-left:5px;"
                       @click="$help('author_institution', StoreLang)">
                    </i>
                  </strong>
                </b-col>
                <b-col lg="8">
                  <b-form-input class="form-control" v-model="author_item.institution"></b-form-input>
                </b-col>
              </b-row>

              <!-- Author ORCID -->
              <b-row style="margin: 3px;">
                <b-col lg="1"></b-col>
                <b-col lg="3">
                  <strong>
                    {{ d_usrShpBundWdm['0']['parameters']['57']['parameters']['63']['name']['translation'][StoreLang] }}
                    <i class="fa fa-info-circle"
                       style="color:#2492FF;margin-left:5px;"
                       @click="$help('author_orcid_id', StoreLang)">
                    </i>
                  </strong>
                </b-col>
                <b-col lg="8">
                  <b-form-input class="form-control" v-model="author_item.orcid_link"></b-form-input>
                </b-col>
              </b-row>

              <hr>
            </div>

            <!-- ================= APPLIED METHODOLOGY ================= -->
            <b-row style="margin: 3px;">
              <b-col lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['43']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('applied_methodology_and_analyses', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col lg="8">
                <b-form-textarea
                  rows="3"
                  class="form-control"
                  v-model="d_bundleData.methodologies_and_analyses_to_be_excluded">
                </b-form-textarea>
              </b-col>
            </b-row>

            <hr>

            <!-- ================= DATA COLLECTION ================= -->
            <b-row style="margin: 3px;">
              <b-col lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['44']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('data_collection_center_count', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col lg="8">
                <b-form-input
                  type="number"
                  class="form-control"
                  v-model="d_bundleData.data_collection_center_count">
                </b-form-input>
              </b-col>
            </b-row>

            <hr>

            <b-row style="margin: 3px;">
              <b-col lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['45']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('data_collection_centers', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col lg="8">
                <b-form-textarea
                  rows="3"
                  class="form-control"
                  v-model="d_bundleData.data_collection_centers">
                </b-form-textarea>
              </b-col>
            </b-row>

            <hr>

            <!-- ================= ARTICLE INFORMATION ================= -->
            <b-row style="margin: 3px;">
              <b-col lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['47']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('dataset_publication_status_in_an_article', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col lg="8">
                <select
                  class="form-control"
                  v-model="d_bundleData.dataset_publication_status_in_an_article">
                  <option value="">-</option>
                  <option
                    v-for="op in d_usrShpBundWdm['0']['parameters']['47'].options"
                    :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>

            <hr>

            <div v-if="d_bundleData.dataset_publication_status_in_an_article == '1'">

              <!-- ================= ARTICLE LIST ================= -->
              <b-row style="margin: 3px; margin-bottom: 10px;">
                <b-col sm="12" lg="4">
                  <strong>
                    {{ d_usrShpBundWdm['0']['parameters']['64']['name']['translation'][StoreLang] }}
                    <i class="fa fa-info-circle"
                       style="color:#2492FF;margin-left:5px;"
                       @click="$help('dataset_publication_status_in_an_article', StoreLang)">
                    </i>
                  </strong>
                </b-col>

                <b-col sm="12" lg="8">
                  <button class="btn btn-success" @click="f_addArticle()">+</button>
                </b-col>
              </b-row>

              <div v-for="(article_item, article_index) in d_bundleData.article_list"
                   :key="'article_' + article_index">

                <!-- Journal Name -->
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="1">
                    <button class="btn btn-danger" @click="f_removeArticle(article_index)">-</button>
                  </b-col>
                  <b-col sm="12" lg="3">
                    <strong>
                      {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['48']['name']['translation'][StoreLang] }}
                      <i class="fa fa-info-circle"
                         style="color:#2492FF;margin-left:5px;"
                         @click="$help('journal_name', StoreLang)">
                      </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-input class="form-control" v-model="article_item.journal_name"></b-form-input>
                  </b-col>
                </b-row>

                <!-- Article Title -->
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="1"></b-col>
                  <b-col sm="12" lg="3">
                    <strong>
                      {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['49']['name']['translation'][StoreLang] }}
                      <i class="fa fa-info-circle"
                         style="color:#2492FF;margin-left:5px;"
                         @click="$help('article_title', StoreLang)">
                      </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-input class="form-control" v-model="article_item.article_title"></b-form-input>
                  </b-col>
                </b-row>

                <!-- Article Link -->
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="1"></b-col>
                  <b-col sm="12" lg="3">
                    <strong>
                      {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['50']['name']['translation'][StoreLang] }}
                      <i class="fa fa-info-circle"
                         style="color:#2492FF;margin-left:5px;"
                         @click="$help('article_link', StoreLang)">
                      </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <b-form-input class="form-control" v-model="article_item.article_link"></b-form-input>
                  </b-col>
                </b-row>

                <!-- ================= ARTICLE AUTHORS ================= -->
                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="1"></b-col>
                  <b-col sm="12" lg="3">
                    <strong>
                      {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['66']['name']['translation'][StoreLang] }}
                      <i class="fa fa-info-circle"
                         style="color:#2492FF;margin-left:5px;"
                         @click="$help('article_authors', StoreLang)">
                      </i>
                    </strong>
                  </b-col>
                  <b-col sm="12" lg="8">
                    <button class="btn btn-success" @click="f_addArticleAuthor(article_index)">+</button>
                  </b-col>
                </b-row>

                <b-row style="margin: 3px;">
                  <b-col sm="12" lg="1"></b-col>
                  <b-col sm="12" lg="11">
                    <div v-for="(article_author_item, article_author_index)
                                in d_bundleData.article_list[article_index].article_authors"
                         :key="'article_author_' + article_author_index">

                      <!-- Article Author Title -->
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="1">
                          <button class="btn btn-danger"
                                  @click="f_removeArticleAuthor(article_index, article_author_index)">-</button>
                        </b-col>
                        <b-col sm="12" lg="3">
                          <strong>
                            {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['66']['parameters']['69']['name']['translation'][StoreLang] }}
                            <i class="fa fa-info-circle"
                               style="color:#2492FF;margin-left:5px;"
                               @click="$help('author_title', StoreLang)">
                            </i>
                          </strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input class="form-control" v-model="article_author_item.title"></b-form-input>
                        </b-col>
                      </b-row>

                      <!-- Firstname -->
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="1"></b-col>
                        <b-col sm="12" lg="3">
                          <strong>
                            {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['66']['parameters']['67']['name']['translation'][StoreLang] }}
                            <i class="fa fa-info-circle"
                               style="color:#2492FF;margin-left:5px;"
                               @click="$help('author_firstname', StoreLang)">
                            </i>
                          </strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input class="form-control" v-model="article_author_item.firstname"></b-form-input>
                        </b-col>
                      </b-row>

                      <!-- Lastname -->
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="1"></b-col>
                        <b-col sm="12" lg="3">
                          <strong>
                            {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['66']['parameters']['68']['name']['translation'][StoreLang] }}
                            <i class="fa fa-info-circle"
                               style="color:#2492FF;margin-left:5px;"
                               @click="$help('author_lastname', StoreLang)">
                            </i>
                          </strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input class="form-control" v-model="article_author_item.lastname"></b-form-input>
                        </b-col>
                      </b-row>

                      <!-- Mail -->
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="1"></b-col>
                        <b-col sm="12" lg="3">
                          <strong>
                            {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['66']['parameters']['70']['name']['translation'][StoreLang] }}
                            <i class="fa fa-info-circle"
                               style="color:#2492FF;margin-left:5px;"
                               @click="$help('author_mail', StoreLang)">
                            </i>
                          </strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input class="form-control" v-model="article_author_item.mail"></b-form-input>
                        </b-col>
                      </b-row>

                      <!-- Institution -->
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="1"></b-col>
                        <b-col sm="12" lg="3">
                          <strong>
                            {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['66']['parameters']['71']['name']['translation'][StoreLang] }}
                            <i class="fa fa-info-circle"
                               style="color:#2492FF;margin-left:5px;"
                               @click="$help('author_institution', StoreLang)">
                            </i>
                          </strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input class="form-control" v-model="article_author_item.institution"></b-form-input>
                        </b-col>
                      </b-row>

                      <!-- ORCID -->
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="1"></b-col>
                        <b-col sm="12" lg="3">
                          <strong>
                            {{ d_usrShpBundWdm['0']['parameters']['64']['parameters']['66']['parameters']['72']['name']['translation'][StoreLang] }}
                            <i class="fa fa-info-circle"
                               style="color:#2492FF;margin-left:5px;"
                               @click="$help('author_orcid_id', StoreLang)">
                            </i>
                          </strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input class="form-control" v-model="article_author_item.orcid_link"></b-form-input>
                        </b-col>
                      </b-row>

                      <hr>
                    </div>
                  </b-col>
                </b-row>

                <hr>
              </div>

            </div>



          </b-card-body>


            <!-- Ethics Committee -->

          <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
            <b-row>
              <b-col sm="12" lg="8">
                <h6>
                  <i class="fa fa-calculator"></i>
                  {{ StoreLangTranslation.data['ethics_committee_information'][StoreLang] }}

                </h6>
              </b-col>
              <b-col sm="12" lg="4" style="text-align: right;"></b-col>
            </b-row>
          </b-card-header>

          <b-card-body>

            <!-- Ethics Committee Approval Institution -->
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['53']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('ethics_committee_approval_institution', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-textarea
                  rows="3"
                  class="form-control"
                  v-model="d_bundleData.ethics_committee_approval_institution">
                </b-form-textarea>
              </b-col>
            </b-row>

            <hr>

            <!-- Ethics Committee Date -->
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['54']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('ethics_committee_date', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-input
                  type="date"
                  class="form-control"
                  v-model="d_bundleData.ethics_committee_date">
                </b-form-input>
              </b-col>
            </b-row>

            <hr>

            <!-- Ethics Committee Protocol Number -->
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ d_usrShpBundWdm['0']['parameters']['55']['name']['translation'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('ethics_committee_protocol_number', StoreLang)">
                  </i>
                </strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-input
                  class="form-control"
                  v-model="d_bundleData.ethics_committee_protocol_number">
                </b-form-input>
              </b-col>
            </b-row>

            <hr>
          </b-card-body>



        <!-- ================= EXCEL FILE ================= -->

          <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
            <b-row>
              <b-col sm="12" lg="8">
                <h6>
                  <i class="fa fa-calculator"></i>
                  {{ StoreLangTranslation.data['excel_file'][StoreLang] }}
                  <i class="fa fa-info-circle"
                     style="color:#2492FF;margin-left:5px;"
                     @click="$help('excel_file', StoreLang)">
                  </i>
                </h6>
              </b-col>
              <b-col sm="12" lg="4" style="text-align: right;"></b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ StoreLangTranslation.data['excel_file'][StoreLang] }}
                </strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-file
                  v-model="d_excelFile"
                  accept=".xlsx, .xls"
                  ref="excelFileInput"
                  @change="f_handleFileUpload"
                  :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
                  :placeholder="StoreLangTranslation.data['select_excel_file'][StoreLang]"
                ></b-form-file>
              </b-col>
            </b-row>
          </b-card-body>
          
          <b-row style="margin: 3px; padding-top: 10px;">
            <b-col sm="12" lg="12">
              <b-form-checkbox v-model="d_approveAgreement">
                {{ StoreLangTranslation.data['read_and_agree'][StoreLang] }}
                <span>
                  <a :href="f_legalPageUrl()" target="_blank">
                    {{ StoreLangTranslation.data['agreement'][StoreLang] }}
                  </a>
                </span>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row style="margin: 3px; padding-top: 10px;">
            <b-col sm="12" lg="12">
              <b-form-checkbox v-model="d_approveAgreementUpload">
                {{ StoreLangTranslation.data['read_and_agree_upload'][StoreLang] }}
                <span>
                </span>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row style="margin: 3px; padding-top: 10px;">
            <b-col sm="12" lg="12">
              <b-button v-if="d_bundleClientId" @click="f_changeToModal('show')" variant="warning">{{ StoreLangTranslation.data['show'][StoreLang] }}</b-button>
              <b-button @click="d_editBundleModal = false" variant="danger" style="float: right;">{{ StoreLangTranslation.data['cancel'][StoreLang] }}</b-button>
              <b-button @click="f_saveBundle()" :disabled="(d_bundleClientId || d_excelFileBase64) && d_approveAgreement && d_approveAgreementUpload ? false : true" variant="success" style="float: right; margin-right: 5px">{{ StoreLangTranslation.data['save'][StoreLang] }}</b-button>
            </b-col>
          </b-row>

      </template>
    </b-modal>

    <b-toast id="copy-toast" variant="success" solid>
      {{ StoreLangTranslation.data['link_copied'][StoreLang] }}
    </b-toast>

    <!-- <b-modal v-if="d_cancelBundleModal" id="d_cancelBundleModal" v-model="d_cancelBundleModal" scrollable hide-footer :title="StoreLangTranslation.data['edit'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['33']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_bundleData.reason_for_cancellation">
              <option value="" selected>-</option>
              <option v-for="(op, op_index) in d_usrShpBundWdm['0']['parameters']['33'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_usrShpBundWdm['0']['parameters']['34']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-textarea rows="3" class="form-control" v-model="d_bundleData.reason_for_cancellation_note"></b-form-textarea>
          </b-col>
        </b-row>

        <b-row style="margin: 3px; padding-top: 10px;">
          <b-col sm="12" lg="12">
            <b-button @click="f_cancelBundle()" :disabled="!d_bundleData.reason_for_cancellation" variant="danger" style="float: right;">{{ StoreLangTranslation.data['save'][StoreLang] }}</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal> -->



    <b-modal
      v-if="d_excelCorrection.show"
      id="d_excelCorrection_show"
      v-model="d_excelCorrection.show"
      hide-footer
      title="Excel Edit"
      centered
      header-bg-variant="info"
      header-text-variant="dark"
      size="xl"
      class="my-big-modal"
    >

      <!-- HEADER -->
      <b-row class="m-1">
        <b-col cols="6">
          <h3>{{ StoreLangTranslation.data['excel_upload_settings'][StoreLang] }}</h3>
        </b-col>
        <b-col cols="6" class="text-right">
          <b-spinner v-if="d_saveLoading" variant="primary" />
          <b-button
            v-else
            variant="outline-success"
            class="mr-1"
            @click="f_saveBundle('modal')"
          >
            {{ StoreLangTranslation.data['save'][StoreLang] }}
          </b-button>
        </b-col>
      </b-row>

      <b-row class="m-1" v-if="d_excelCorrection.correction_column_list.length > 0">
        <b-col cols="12">
          <span style="color: red">1. {{ StoreLangTranslation.data['excel_warning_1'][StoreLang] }}</span>
        </b-col>
        <b-col cols="12">
          <span style="color: red">2. {{ StoreLangTranslation.data['excel_warning_2'][StoreLang] }}</span>
        </b-col>
      </b-row>

      <b-row class="m-1" v-if="d_excelCorrection.correction_column_list.length">
        <b-col cols="12">
          <strong>{{ StoreLangTranslation.data['correction_suggestions'][StoreLang] }}</strong>
        </b-col>
      </b-row>

      <!-- TABLE -->
      <b-table-simple
        v-if="d_excelCorrection.correction_column_list.length"
        small
        caption-top
        class="correction-table-fixed-header"
      >
        <b-thead head-variant="dark">
          <b-tr>
            <b-th style="width:20px">#</b-th>
            <b-th style="width:120px">{{ StoreLangTranslation.data['column'][StoreLang] }}</b-th>
            <b-th style="width:150px">{{ StoreLangTranslation.data['column_type'][StoreLang] }}</b-th>
            <b-th style="width:80px">{{ StoreLangTranslation.data['number_of_empty_cells'][StoreLang] }}</b-th>
            <b-th style="width:120px">{{ StoreLangTranslation.data['value_to_write_to_empty_cells'][StoreLang] }}</b-th>
            <b-th style="width:200px">{{ StoreLangTranslation.data['numeric_values'][StoreLang] }}</b-th>
            <b-th style="width:300px">{{ StoreLangTranslation.data['option_to_replace'][StoreLang] }}</b-th>
            <b-th style="width:200px">{{ StoreLangTranslation.data['column_incompatible'][StoreLang] }}</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr
            v-for="(col, col_ind) in d_excelCorrection.correction_column_list"
            :key="col_ind"
            :class="{ 'even-row': col_ind % 2 === 0 }"
          >
            <b-td style="width:20px">{{ col_ind + 1 }}</b-td>

            <b-td style="width:120px">
              <!-- <strong class="text-truncate d-block">{{ col.label }}</strong> -->
              <strong>{{ col.label }}</strong>
            </b-td>

            <b-td :style="{ width: '150px', backgroundColor: d_paramTypeColors[col.param_type]}">
              <b-form-select v-model="col.param_type" size="sm" :style="{backgroundColor: d_paramTypeColors[col.param_type]}">
                <option value="text" style="background-color: white;">{{ StoreLangTranslation.data['type_text'][StoreLang] }}</option>
                <option value="select" style="background-color: white;">{{ StoreLangTranslation.data['type_select'][StoreLang] }}</option>
                <option value="float" style="background-color: white;">{{ StoreLangTranslation.data['type_float'][StoreLang] }}</option>
                <option value="integer" style="background-color: white;">{{ StoreLangTranslation.data['type_integer'][StoreLang] }}</option>
                <option value="datetime" style="background-color: white;">{{ StoreLangTranslation.data['type_datetime'][StoreLang] }}</option>
              </b-form-select>
            </b-td>

            <b-td style="width:80px" class="text-center">{{ col.null_count }}</b-td>

            <b-td style="width:120px">
              <b-form-input v-model="col.value_for_null" size="sm" />
            </b-td>

            <b-td style="width:200px" class="small">
              <template v-if="col.param_type === 'integer' || col.param_type === 'float'">
                <div v-if="col.mean_value"><strong>Ortalama:</strong> {{ (+col.mean_value).toFixed(2) }}</div>
                <div v-if="col.minimum_value || col.maximum_value"><strong>Min / Max:</strong> {{ col.minimum_value || '-' }} / {{ col.maximum_value || '-' }}</div>
                <div v-if="col.standart_deviation"><strong>Standart Sapma:</strong> {{ (+col.standart_deviation).toFixed(2) }}</div>
                <div v-if="col.outliers_interquartile_range">
                  <strong>Alt / Üst (IQR):</strong>
                  {{ (+col.outliers_interquartile_range.lower_bound).toFixed(2) }} /
                  {{ (+col.outliers_interquartile_range.upper_bound).toFixed(2) }}
                </div>
              </template>
              <span v-else>-</span>
            </b-td>

            <b-td style="width:300px">
              <div v-if="col.param_type === 'select'" class="option-box">
                <div v-for="(opt, i) in col.options" :key="i" class="mb-1">
                  <small><strong>{{ opt.label }}</strong> / {{ opt.count }}</small>
                  <b-form-input v-model="opt.correct_label" size="sm" />
                </div>
              </div>
              <span v-else>-</span>
            </b-td>

            <b-td style="width:200px">
              <div class="error-box" v-if="col.incompatible_with_column_type">
                <div v-for="(v, k) in col.incompatible_with_column_type" :key="k">
                  <small>{{ k }} →</small>
                  <b-form-input v-model="v.val" size="sm" class="d-inline-block w-50" />
                </div>
              </div>
              <span v-else>-</span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>



  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import { mapGetters } from 'vuex';
import {
  default as WTable2
} from '@/components/widgets/WTable2';
import {
  default as HtmlEditor
} from '@/wam/components/widgets/HtmlEditor';
export default {
  name: 'user_shop_bundle_list',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',

  }),
  components: {
    WTable2,
    HtmlEditor,
  },
  props: {},
  data () {
    return {
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_usrCreatedBundleList: [],
      d_bundleListLoading: false,
      d_shopList: [],
      d_usrShpBundWdm: '',
      d_userShopBundleProductWdm: '',
      d_bundleData: {
        'status': '',
        'bundle_name': '',
        'dataset_creator_note': '',
        'communication_with_the_user_requesting_the_dataset': '',
        'dataset_creator_phone': '',
        'dataset_creator_mail': '',
        'dataset_creator_note_to_requester': '',
        'reason_for_cancellation': '',
        'reason_for_cancellation_note': '',
        'special_acknowledgement_request_status': '',
        'special_acknowledgement_text': '',
        'demo_dataset': '',
        'row_count': '',
        'column_count': '',
        'various_variables': '',
        'about_dataset': '',
        'dataset_usage_type': '',
        'methodologies_and_analyses_to_be_excluded': '',
        'data_collection_center_count': '',
        'data_collection_centers': '',
        'licence_type': '',
        'dataset_publication_status_in_an_article': '',
        'journal_name': '',
        'article_title': '',
        'link': '',
        'which_one_best_describes_your_reason_for_sharing_dataset': '',
        'visiting_research_institution_request_text': '',
        'ethics_committee_approval_institution': '',
        'ethics_committee_date': '',
        'ethics_committee_protocol_number': '',
        'author_list': [],
        'article_list': [],
      },
      d_productData: {
        'status': '',
        'pro_info': '',
        'wanalyzer_project_id': {},
      },
      ClsUser: ClsUser,
      d_bundleClientId: '',
      d_shopClientId: '',
      d_bundleWdmr: '',
      d_editBundleModal: false,
      d_showBundleModal: false,
      d_modalLoading: false,
      d_saveLoading: false,
      d_datasetViewLoading: false,
      d_excelFile: null,
      d_excelFileName: '',
      d_excelFileBase64: '',
      d_datasetWTable: '',
      d_frontendData: {
        'application_name': {},
        'are_shop_pages_active': '',
        'login_background_color': '',
        'login_buttons_background_color': '',
        'login_card_in_background_color': '',
        'login_card_in_shadow_color': '',
        'login_card_out_background_color': '',
        'login_card_out_shadow_color': '',
        'login_function': '',
        'register_function': '',
        'login_function_external': '',
        'login_inputs_border_color': '',
        'login_loading_background_color': '',
        'login_slogan_text': {},
        'mail_api_send_mail_uri': '',
        'mail_api_token_password': '',
        'mail_api_token_uri': '',
        'mail_api_token_username': '',
        'menu_background_color': '',
        'menu_border_bottom_color': '',
        'menu_box_shadow_color': '',
        'menu_child_item_background_color': '',
        'menu_child_item_border_bottom_color': '',
        'menu_child_item_text_color': '',
        'navbar_application_name_color': '',
        'menu_parent_item_background_color': '',
        'menu_parent_item_border_bottom_color': '',
        'menu_parent_item_text_color': '',
        'menu_top_caption': {},
        'menu_type': '',
        'meta': '',
        'meta_value': '',
        'navbar_application_name_shadow_color': '',
        'navbar_background_color': '',
        'password_reset_mail_approve_frontend_uri_and_route': {},
        'password_reset_mail_approve_link_text': {},
        'password_reset_mail_approve_subject': {},
        'privacy_policy_link': {},
        'register_mail_approve_frontend_uri_and_route': {},
        'register_mail_approve_link_text': {},
        'register_mail_approve_mail_from': '',
        'register_mail_approve_mail_from_password': '',
        'register_mail_approve_subject': {},
        'mail_privacy_notice_text': {},
        'mail_smtp_address': '',
        'mail_smtp_username': '',
        'mail_smtp_password': '',
        'status': '',
        'terms_of_service_link': {},
        'wanalyzer_api_password': '',
        'wanalyzer_api_url': '',
        'wanalyzer_api_username': '',
        'wanalyzer_frontend_url': '',
        'wmanager_uri': '',
        'worganization_api_password': '',
        'worganization_api_url': '',
        'worganization_api_username': '',
        'worganization_frontend_url': '',
        'worganization_organizasyon_id_values': '',
        'worganization_token': '',
        'waccount_external_key': '',
        'waccount_url': '',
        'waccount_username': '',
        'waccount_password': '',
        'waccount_system_product_id': '',
        'worganization_user_id': '',
        'application_frontend_uri': '',
        'application_backend_uri': '',
        'support_details_subject': {},
        'support_mail_from': '',
        'support_mail_from_password': '',
        'support_details_link_text': {},
        'support_details_frontend_uri_and_route': {},
        'page_area_text_color': {},
        'footer_text_color': {},
        'footer_background_color': {},
        'navbar_text_color': {},
        'facebook_link': {},
        'twitter_link': {},
        'instagram_link': {},
        'linkedin_link': {},
        'login_background_image': {},
        'footer_date': '',
        'navbar_flowing_text': {},
        'footer_date': '',
        'footer_text_padding': '',
        'footer_text_size': '',
        'footer_text_weight': '',
        'general_font_select': '',
        'general_font_size': '',
        'general_font_style': '',
        'general_font_weight': '',
        'general_text_color': '',
        'language_options': [],
        'market_visiblity_type': '',
        'navbar_font_size': '',
        'navbar_text_weight': '',
        'page_favicon': '',
        'default_language': '',
        'language_change_button_visibility': '',
        'google_analytics_id': '',
        'login_button_name': {},
        'language_change_button_type': '',
        'domain': '',
        'package_groups_to_show_in_shop': {},
        'shop_view': '',
        'users_can_upload_dataset': '',
        'wanalyzer_credit_usage': '',
      },
      d_frontendLoading: true,
      d_approveAgreement: false,
      d_approveAgreementUpload: false,
      d_cancelBundleModal: false,
      d_OrderList: {},
      d_excelCorrection: {
        'correction_column_list': [],
        'show': false,
        'column_type': 'clear',
        'column_design': 'create_new_column_types',
        'dataset_type': 'clear',
      },
      d_inputEditorMode: 'html',
      d_paramTypeColors: {
        'text': '#f7f3ff',
        'select': '#ffe5e5',
        'float': '#e5f0ff',
        'integer': '#e8ffe5',
        'datetime': '#fff3e0',
      },
      d_htmlParameters: [
        'about_dataset',
        'various_variables',
      ],
      d_projectList: {},
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shp_bund_pro').then(resp_wdm_data => { this.d_userShopBundleProductWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.f_getFrontendSettings();
    // this.f_getOrderList(['wisdom_182f1223-058e-4f3b-9f82-5c3b539deb03', 'wisdom_0d4206b1-fabe-4078-96e4-4f8b575c1aa9', 'wisdom_f0581032-2256-4fdb-8fc2-e39b641bb529']);


    // console.log('this.d_frontendData.users_can_upload_dataset : ',this.d_frontendData.users_can_upload_dataset)
    // console.log('this.d_frontendData.are_shop_pages_active : ',this.d_frontendData.are_shop_pages_active)
    // if (this.d_user && this.d_user.username && this.d_frontendData.are_shop_pages_active === '1' && this.d_frontendData.users_can_upload_dataset === '1') {
    //   this.f_userCreatedBundleList();
    //   this.f_langEligibleParameterProcess();
    // } else {
    //   this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    // }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
  },
  methods: {
    f_goToProject: function (bundle_id) {
      const origin = window.location.origin;
      const route_lang = {
        'tr': '/kullanici-proje/dataset-filtrele',
        'en': '/user-project/dataset-filter'
      }
      const newPath = route_lang[this.StoreLang] + '?project_id=' + this.d_projectList[bundle_id] + '&project_type=wanalyzer_dataset_filter';
      const newUrl = origin + newPath;
      // console.log(newUrl)
      window.open(newUrl, '_blank');
      // kullanici-proje/dataset-filtrele?project_id=37d4046e-b931-47c7-b803-674dc9800dfc&project_type=wanalyzer_dataset_filter
      // user-project/dataset-filter?project_id=a4ec9e8f-6559-457e-98b8-92d77671f702&project_type=wanalyzer_dataset_filter
    },
    f_copyShortLink: function (dataset_id) {
      const origin = window.location.origin;
      const newPath = '/dataset?did=' + dataset_id;
      const newUrl = origin + newPath;

      navigator.clipboard.writeText(newUrl)
        .then(() => {
          this.$bvToast.show('copy-toast');
        })
        .catch(err => {
          // Hata bildirimi
          this.$bvToast.toast(this.StoreLangTranslation.data['process_completed'][this.StoreLang] + err, {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 3000
          });
        });
    },
    f_changeInputEditorMode: function(editor_mode, param_location, selected_parameter_id){
      if(editor_mode == "text"){
        for (let html_param of this.d_htmlParameters) {
          let div_el = document.getElementById("website_html_edit_" + html_param);
          param_location[html_param] = div_el.innerHTML;
        }
      }
      setTimeout(function () {
        this.d_inputEditorMode = editor_mode;
      }.bind(this), 50);
    },
    f_addArticleAuthor(article_index) {
      this.d_bundleData.article_list[article_index].article_authors.push({
        'firstname': "",
        'lastname': "",
        'title': "",
        'mail': "",
        'institution': "",
        'orcid_link': "",
      });
    },
    f_removeArticleAuthor(article_index, article_author_index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_bundleData.article_list[article_index].article_authors.splice(article_author_index, 1);
      }
    },
    f_addArticle() {
      this.d_bundleData.article_list.push({
        'article_status': '0',
        'journal_name': '',
        'article_title': '',
        'article_link': '',
        'article_date': '',
        'article_authors': [],
      });
    },
    f_removeArticle(index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_bundleData.article_list.splice(index, 1);
      }
    },
    f_addAuthor() {
      this.d_bundleData.author_list.push({
        'firstname': "",
        'lastname': "",
        'title': "",
        'mail': "",
        'institution': "",
        'orcid_link': "",
      });
    },
    f_removeAuthor(index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_bundleData.author_list.splice(index, 1);
      }
    },
    f_getOrderList: function (user_shop_bundle_client_id_list) {
      let query = '';
      // let query = 'user_shop_bundle_client_id=' + user_shop_bundle_client_id;
      let data = {
        'user_shop_bundle_client_id_list': user_shop_bundle_client_id_list
      }
      // let data = {};
      // this.d_frontendLoading = true;
      ServiceFunctions.user_created_bundle_order_list(query, data)
        .then(resp => {
          // this.d_frontendLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_OrderList = resp.data.list;
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_legalPageUrl: function () {
      let legal_url = window.location.origin + '/legal';
      return legal_url;
    },
    f_getFrontendSettings: function () {
      let query = 'ss=1';
      let data = {};
      this.d_frontendLoading = true;
      ServiceFunctions.frontend_get(query, data)
        .then(resp => {
          this.d_frontendLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_frontendData = resp.data.frontend;
            this.$store.commit('MutationFrontendSettings', { 'status': 1, 'data': this.d_frontendData });
            if (this.d_user && this.d_user.username && this.d_frontendData.are_shop_pages_active === '1' && this.d_frontendData.users_can_upload_dataset === '1') {
              this.f_userCreatedBundleList();
              this.f_langEligibleParameterProcess();
            } else {
              this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_changeToModal: function (new_modal) {
      if (new_modal == 'show') {
        this.d_editBundleModal = false;
        this.d_showBundleModal = true;
        if (this.d_productData['wanalyzer_project_id'] && this.d_productData['wanalyzer_project_id'][this.StoreLang] && !this.d_datasetWTable) {
          this.f_wanalyzerProjectDatasetGet();
        }
      } else if (new_modal == 'edit') {
        this.d_showBundleModal = false;
        this.d_editBundleModal = true;
      }
    },
    f_wanalyzerProjectDatasetGet: function (bundle_client_id) {
      this.d_datasetViewLoading = true;
      let query = 'project_id=' + this.d_productData['wanalyzer_project_id'][this.StoreLang];


      // hangi tipte yetki ataması yapılacaksa kullanıcıya o eklenecek
      query += '&auth_client_id=' + this.d_user['username'] + "_" + this.d_productData['wanalyzer_project_id'][this.StoreLang] + "_dataset_filter";


      let data = {
        'pagination': '',
        'filter_rule': {},
        'wai_columns': 'no',
        'bundle_client_id': this.d_bundleClientId,
      };
      this.d_datasetWTable = '';
      ServiceFunctions.wanalyzer_project_dataset_get(query, data)
        .then(resp => {
          this.d_datasetViewLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_datasetWTable = resp.data.wtable;
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    // f_checkRequiredFields: function () {
    //   let res = true;
    //   for (let lang_index in this.StoreLangList.data) {
    //     console.log(this.d_productData.pro_name)
    //     console.log(this.StoreLangList.data[lang_index]['translation'][this.StoreLang])
    //     if (this.d_productData.pro_name[this.StoreLangList.data[lang_index]['translation'][this.StoreLang]] === '') {
    //       res = false;
    //       break;
    //     }
    //     if (!this.d_bundleClientId && !this.d_excelFileBase64) {
    //       res = false;
    //       break;
    //     }
    //   }
    //   return res;
    // },
    // f_showCancel: function (user_shop_bundle_client_id, user_shop_client_id) {
    //   this.d_bundleClientId = user_shop_bundle_client_id;
    //   this.d_shopClientId = user_shop_client_id;
    //   this.d_bundleData['reason_for_cancellation_note'] = '';
    //   this.d_cancelBundleModal = true;
    // },
    // f_cancelBundle: function () {
    //   let res = true;
    //   if (!this.d_bundleData.reason_for_cancellation) {
    //     alert(this.StoreLangTranslation.data['empty_fields'][this.StoreLang]);
    //     res = false;
    //   }
    //   if (res) {
    //     this.d_saveLoading = true;
    //     let query = 'user_client_id=' + this.d_user.username;
    //     query += '&user_shop_client_id=' + this.d_shopClientId;
    //     query += '&user_shop_bundle_client_id=' + this.d_bundleClientId;
    //     let data = {
    //       'bundle_data': this.d_bundleData,
    //     };
    //     ServiceFunctions.user_created_bundle_cancel(query, data)
    //       .then(resp => {
    //         this.d_saveLoading = false;
    //         if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
    //           // console.log('basariliiii')
    //           alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
    //           this.f_userCreatedBundleList();
    //           this.d_cancelBundleModal = false;
    //         } else {
    //           alert(resp.data.status_code + ' = ' + resp.data.status_message);
    //         }
    //       });
    //   }
    // },
    f_saveBundle: function (call_from) {
      console.log("save...");
      // this.d_excelCorrection.correction_column_list = []
      try {
        if(this.d_inputEditorMode == 'html'){
          for (let lang of this.StoreLangList.data) {
            for (let html_param of this.d_htmlParameters) {
              let div_el = document.getElementById("website_html_edit_" + html_param);
              this.d_bundleData[html_param] = div_el.innerHTML;
            }
          }
        }
      } catch {}
      let res = true;
      if (!this.d_bundleData.bundle_name) {
        alert(this.StoreLangTranslation.data['empty_fields'][this.StoreLang]);
        res = false;
      }
      if (res) {
        this.d_saveLoading = true;
        let query = 'user_client_id=' + this.d_user.username;
        query += '&user_shop_client_id=' + this.d_shopClientId;
        if (this.d_bundleClientId) {
          query += '&user_shop_bundle_client_id=' + this.d_bundleClientId;
        }
        let data = {
          'bundle_data': this.d_bundleData,
          'product_data': this.d_productData,
          'correction_column_list': this.d_excelCorrection.correction_column_list,
        };
        if (this.d_excelFileBase64) {
          data['excel_file'] = this.d_excelFileBase64;
        }
        // console.log(data)
        ServiceFunctions.user_created_bundle_record(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
              // this.d_bundleData = resp.data['bundle_data'];
              // this.d_productData = resp.data['product_data'];
              // // this.f_langEligibleParameterProcess();
              // this.f_userCreatedBundleList();
              // // this.$forceUpdate();
              // this.f_changeToModal('show');
              this.d_editBundleModal = false;
              if (call_from == 'modal') {
                this.f_userCreatedBundleList();
                this.f_langEligibleParameterProcess();
              } else {
                this.d_bundleClientId = resp.data['bundle_client_id'];
              }

              this.d_excelCorrection.correction_column_list = []
              try {
                this.d_excelCorrection.correction_column_list = resp.data.excel_response.result.correction_column_list;
              } catch (err) {}
              if (call_from === 'modal' || this.d_excelCorrection.correction_column_list.length === 0) {
                this.d_excelCorrection.show = false;
                this.d_excelCorrection.correction_column_list = []
              } else {
                this.d_excelCorrection.show = true;
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_copyDataAvailabilityStatement: function (bundle_id, language) {

      // The dataset generated and analyzed in this study is publicly available on the Istinye University Dataset Sharing Platform. Anonymized data can be accessed at the following link: https:/dataset.istinye.edu.tr/dataset?did=60. All data were fully anonymized in accordance with ethical regulations. Access is provided for research purposes through a controlled-access system under the platform’s standard licensing and data-sharing policies.

      // Bu çalışmada oluşturulan ve analiz edilen veri seti, İstinye Üniversitesi Veri Seti Paylaşım Platformu'nda kamuya açıktır. Anonimleştirilmiş verilere şu bağlantıdan erişilebilir: https:/dataset.istinye.edu.tr/dataset?did=60. Tüm veriler etik düzenlemelere uygun olarak tamamen anonimleştirilmiştir. Erişim, platformun standart lisanslama ve veri paylaşım politikaları kapsamında kontrollü erişim sistemi aracılığıyla araştırma amaçlı olarak sağlanmaktadır.

      const origin = window.location.origin;
      const didPath = '/dataset?did=' + bundle_id;
      const didUrl = origin + didPath;
      let shop_name = '';
      if (this.d_shopList[0]['wdmr'].data['0']['31'] && this.d_shopList[0]['wdmr'].data['0']['31']['val']) {
        shop_name = this.d_shopList[0]['wdmr'].data['0']['31']['lang'][language]
      } else {
        shop_name = this.d_shopList[0]['wdmr'].data['0']['1']['lang'][language]
      }
      let dataAvailabilityStatementText = ''
      if (language == 'en') {
        dataAvailabilityStatementText += 'The dataset generated and analyzed in this study is publicly available on the ' + shop_name + ' Dataset Sharing Platform. Anonymized data can be accessed at the following link: ' + didUrl + '. All data were fully anonymized in accordance with ethical regulations. Access is provided for research purposes through a controlled-access system under the platform’s standard licensing and data-sharing policies.'
      } else if (language == 'tr') {
        dataAvailabilityStatementText += 'Bu çalışmada oluşturulan ve analiz edilen veri seti, ' + shop_name + ' Veri Seti Paylaşım Platformu\'nda kamuya açıktır. Anonimleştirilmiş verilere şu bağlantıdan erişilebilir: ' + didUrl + '. Tüm veriler etik düzenlemelere uygun olarak tamamen anonimleştirilmiştir. Erişim, platformun standart lisanslama ve veri paylaşım politikaları kapsamında kontrollü erişim sistemi aracılığıyla araştırma amaçlı olarak sağlanmaktadır.'
      }
      // console.log(dataAvailabilityStatementText);

      navigator.clipboard.writeText(dataAvailabilityStatementText)
        .then(() => {
          this.$bvToast.toast(this.StoreLangTranslation.data['copied'][this.StoreLang], {
            title: 'Bilgi',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 2000,
            solid: true
          });
        })
        .catch(err => {
          this.$bvToast.toast(this.StoreLangTranslation.data['copy_error'][this.StoreLang], {
            title: 'Hata',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 3000,
            solid: true
          });
          console.error(err);
        });

    },
    f_handleFileUpload: function (event) {
      const file = event.target.files[0];
      if (file) {
        if (file.name.endsWith('.xls') || file.name.endsWith('.xlsx')) {
          const max_size_bytes = 50 * 1024 * 1024;
          if (file.size > max_size_bytes) {
            alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang] + ' (max 50mb)');
            this.d_excelFile = null;
            this.d_excelFileBase64 = '';
            this.d_excelFileName = '';
            this.$refs.excelFileInput.reset();
          } else {
            this.d_excelFileName = file.name;

            var vm = this;
            var reader = new FileReader();
            reader.addEventListener('load', function () {
              vm.d_excelFileBase64 = reader.result;
              vm.$forceUpdate();
            }, false);
            reader.readAsDataURL(file);
          }

        } else {
          this.d_excelFile = null;
          this.d_excelFileBase64 = '';
          this.d_excelFileName = '';
          this.$refs.excelFileInput.reset();
          this.$bvToast.toast(this.StoreLangTranslation.data['upload_only_excel_file'][this.StoreLang], {
            title: this.StoreLangTranslation.data['invalid_file_type'][this.StoreLang],
            variant: 'danger',
            solid: true,
          });
        }

      } else {
        this.d_excelFileName = '';
      }
    },
    f_newBundle: function () {
      this.d_editBundleModal = true;
      this.d_modalLoading = true;
      this.f_prepareNewBundle()
        .then(() => {
          this.d_modalLoading = false;
        });
    },
    f_prepareNewBundle: function () {
      return new Promise((resolve) => {
        this.d_bundleClientId = '';
        if (this.d_shopList.length > 1) {
          this.d_shopClientId = '';
        } else {
          this.d_shopClientId = this.d_shopList[0]['client_id'];
        }
        this.d_bundleData = {
          'status': '',
          'bundle_name': '',
          'dataset_creator_note': '',
          'communication_with_the_user_requesting_the_dataset': '',
          'dataset_creator_phone': '',
          'dataset_creator_mail': '',
          'dataset_creator_note_to_requester': '',
          'reason_for_cancellation': '',
          'reason_for_cancellation_note': '',
          'special_acknowledgement_request_status': '',
          'special_acknowledgement_text': '',
          'demo_dataset': '',
          'row_count': '',
          'column_count': '',
          'various_variables': '',
          'about_dataset': '',
          'dataset_usage_type': '',
          'methodologies_and_analyses_to_be_excluded': '',
          'data_collection_center_count': '',
          'data_collection_centers': '',
          'licence_type': '',
          'dataset_publication_status_in_an_article': '',
          'journal_name': '',
          'article_title': '',
          'link': '',
          'which_one_best_describes_your_reason_for_sharing_dataset': '',
          'visiting_research_institution_request_text': '',
          'ethics_committee_approval_institution': '',
          'ethics_committee_date': '',
          'ethics_committee_protocol_number': '',
          'author_list': [],
          'article_list': [],
        };
        this.d_productData = {
          'status': '',
          'pro_info': '',
          'wanalyzer_project_id': {}
        };
        this.f_langEligibleParameterProcess();
        resolve();
      });
    },
    f_showBundle: function (user_shop_bundle_client_id, user_shop_client_id) {
      this.d_bundleClientId = user_shop_bundle_client_id;
      this.d_shopClientId = user_shop_client_id;
      this.d_showBundleModal = true;
      this.d_modalLoading = true;

      let query = 'user_shop_bundle_client_id=' + this.d_bundleClientId;
      query += '&user_shop_client_id=' + this.d_shopClientId;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_created_bundle_get(query, data)
        .then(resp => {
          this.d_modalLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_bundleData = resp.data['bundle_data'];
            this.d_productData = resp.data['product_data'];
            // this.f_langEligibleParameterProcess();
            if (this.d_productData['wanalyzer_project_id'] && this.d_productData['wanalyzer_project_id'][this.StoreLang]) {
              this.f_wanalyzerProjectDatasetGet();
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['wanalyzer_project_id'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          if (!this.d_productData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
            this.d_productData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
          }
        }
      }
    },
    f_editBundle: function (user_shop_bundle_client_id, user_shop_client_id) {
      this.d_bundleClientId = user_shop_bundle_client_id;
      this.d_shopClientId = user_shop_client_id;
      this.d_editBundleModal = true;
      this.d_modalLoading = true;

      let query = 'user_shop_bundle_client_id=' + this.d_bundleClientId;
      query += '&user_shop_client_id=' + this.d_shopClientId;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_created_bundle_get(query, data)
        .then(resp => {
          this.d_modalLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_bundleData = resp.data['bundle_data'];
            this.d_productData = resp.data['product_data'];
            this.f_langEligibleParameterProcess();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_searchUserShopBundle: function (usr_shp_bund) {
      let res = false;
      if (this.d_searchText) {
        for (let i in this.StoreLangList.data) {
          if (usr_shp_bund['data']['0']['1']['lang'][this.StoreLangList.data[i]['translation'][this.StoreLang]].toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
            res = true;
            break;
          }
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userCreatedBundleList: function () {
      this.d_bundleListLoading = true;
      this.d_usrCreatedBundleList = [];
      this.d_shopList = [];
      this.d_projectList = {};
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_created_bundle_list(query, data)
        .then(resp => {
          this.d_bundleListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_usrCreatedBundleList = resp.data.list;
              this.d_shopList = resp.data.shop_list;
              this.d_projectList = resp.data.project_list;
              let arr = []
              for (let i in this.d_usrCreatedBundleList) {
                arr.push(this.d_usrCreatedBundleList[i]['client_id'])
              }
              if (arr.length > 0) {
                this.f_getOrderList(arr);
              }

            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
    d_showBundleModal: function () {
      if (!this.d_editBundleModal && !this.d_showBundleModal && this.d_datasetWTable) {
        this.d_datasetWTable = '';
      }
      this.d_approveAgreement = false;
      this.d_approveAgreementUpload = false;
    },

    d_editBundleModal: function () {
      if (!this.d_editBundleModal && !this.d_showBundleModal && this.d_datasetWTable) {
        this.d_datasetWTable = '';
      }
      this.d_approveAgreement = false;
      this.d_approveAgreementUpload = false;
    },
    'd_excelCorrection.show': function () {
      if (this.d_excelCorrection.show == false) {
        this.d_excelCorrection.correction_column_list = [];
      }
    }
  }
};

</script>


<style>
#d_excelCorrection_show .modal-dialog {
  max-width: 95vw !important;
  width: 95vw !important;
}
#d_excelCorrection_show .modal-content {
  height: 90vh !important;
}

/* Tabloya table-layout: fixed atar ve başlık hücrelerinin genişliklerini korumasını sağlar. */
.correction-table-fixed-header {
    table-layout: fixed;
    width: 100%; 
}

/* TH'lerin sabitlenmesi için zorunlu CSS */
.correction-table-fixed-header thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    /* Başlığın kaybolmaması için arka plan rengini zorlayın */
    background-color: #343a40; 
}

/* Tbody'yi blok seviyesinde gösterip kaydırma ekler. */
.correction-table-fixed-header tbody {
    display: block;
    overflow-y: auto;
    /* max-height 55vh'den 65vh'ye (veya daha yüksek bir değere) çıkarıldı. 
       Bu, modalin altındaki beyaz boşluğu doldurmak için daha fazla alan kullanır. */
    max-height: 55vh; 
}

/* Tbody display: block olduğunda, içerideki TR'lerin genişliğini başlık genişliğine eşitler */
.correction-table-fixed-header tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}
.fa-info-circle {
  cursor: pointer;
}
</style>